// Module
var code = `<div class="modal-dialog" style="display: flex; height: 100%; justify-content: center" data-bind="react: {
		component: ReactUpgradeModal,
		props: {
			featureName: featureName,
			featureId: featureId,
			trackingSource: source,
			features: features,
			onClose: () => clickedCancel()
		}
	}"></div>
`;
// Exports
export default code;